export class SolicitudGerente{
    buscoinformacion:string="";
    folio:string="";
    correoc:boolean=false;
    celular:boolean=false;
    //fijo:boolean=false;
    todos:boolean=false;
    nombre:string="";
    apellido1:string="";
    apellido2:string="";
    correo:string="";
    telefonocelular:string="";
    telefonofijo:string="";
    mensaje:string="";
    idgerente:number=0;
}

